module.exports = __webpack_public_path__ + "img/fig06.660b3699.jpg";